<template>
  <v-card-title>
    <v-container class="pa-1">
      <v-card class="pa-16">
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>New Employee Activity</h3>
            </v-col>
          </v-row>
        </v-card-title>
        <br />
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="12" sm="5" md="5">
              <h3>Employee</h3>
              <v-autocomplete v-model="dataItem.userId" :items="Emp_list" item-text="name" item-value="id" outlined
                dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="5" md="5">
              <h3>Assignment<Title></Title>
              </h3>
              <v-autocomplete v-model="dataItem.jobtitle_id" :items="jobtitle_list" item-text="name" item-value="id"
                outlined dense></v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="space-around">
            <v-col cols="12" sm="5" md="5">
              <h3>Client</h3>
              <v-autocomplete v-model="dataItem.customer_id" :items="customer_list" item-text="name" item-value="id"
                outlined @click:clear="
                  $nextTick(() => {
                    dataItem.customer_id = 0;
                  })
                  " dense></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <h3>Charge Type</h3>
              <v-autocomplete v-model="dataItem.chargetype" :items="charge_list" item-text="name" item-value="value"
                outlined dense></v-autocomplete>
            </v-col>
          </v-row>

          <v-row justify="space-around">
            <v-col cols="12" sm="5" md="5">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-menu v-model="menuDateCheckin" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <h3>Date</h3>
                      <v-text-field v-model="computedDateCheckInFormatted" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="dataItem.checkin" :max="new Date(
                      Date.now() - new Date().getTimezoneOffset() * 60000,
                    )
                      .toISOString()
                      .substr(0, 10)
                      " :min="minDateAllowed" @input="menuDateCheckin = false" @change="getWorkHourDuration()" />
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3>Start Time</h3>
                  <datetime class="border-dt-picker minheighttime" type="time" input-id="menutimeadd"
                    value-zone="Asia/Bangkok" format="HH:mm" v-model="dataItem.timecheckin" :max-datetime="getMaxTime()"
                    :disabled="isDisabledTimeField" @input="getWorkHourDuration" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3>End Time</h3>
                  <datetime class="border-dt-picker minheighttime" type="time" input-id="menutimeadd"
                    value-zone="Asia/Bangkok" format="HH:mm" v-model="dataItem.timecheckout"
                    :max-datetime="getMaxTimeCheckOut()" :disabled="isDisabledTimeFieldCheckOut"
                    @input="getWorkHourDuration()"></datetime>
                </v-col>
              </v-row>
              <!-- <v-row style="margin-top: -30px;">
                <v-col cols="12" sm="7" md="7">
                  <v-menu
                    v-model="menuDateCheckout"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <h3>End Date</h3>
                      <v-text-field
                        v-model="computedDateCheckOutFormatted"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="dataItem.checkout"
                      @input="menuDateCheckout = false"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"

                      @change="getWorkHourDuration()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                  <h3>Time</h3>
                  <datetime
                    class="border-dt-picker minheighttime"
                    type="time"
                    input-id="menutimeadd"
                    value-zone="Asia/Bangkok"
                    format="HH:mm"
                    v-model="dataItem.timecheckout"
                    :max-datetime="getMaxTimeCheckOut()"
                    :disabled="isDisabledTimeFieldCheckOut"
                    @input="getWorkHourDuration()"
                  ></datetime>
                </v-col>
              </v-row> -->

              <v-row v-if="showDuration != ''" style="margin-top: -30px;">
                <v-col cols="12" sm="12" md="12" class="d-flex" v-if="
                  showDuration !=
                  'Start date/time must be before End date/time'
                ">
                  <h3>Duration:</h3>
                  &nbsp;&nbsp;<span style="color: green">{{
                    showDuration
                  }}</span>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="d-flex" v-else>
                  <h3>Duration:</h3>
                  &nbsp;&nbsp;<span style="color: red">{{ showDuration }}</span>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <!-- <h3>Prospect</h3>
              <v-text-field
                dense
                v-model="dataItem.prospect"
                outlined
              ></v-text-field> -->
              <h3>Details</h3>
              <v-textarea v-model="dataItem.detail" multi-line outlined dense></v-textarea>
            </v-col>
          </v-row>
          <!-- <v-row justify="space-around">
            <v-col cols="12" sm="5" md="5">
              <v-row>
                <v-col cols="12" sm="7" md="7">
                  <v-menu
                    v-model="menuDateCheckout"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <h3>End Date</h3>
                      <v-text-field
                        v-model="computedDateCheckOutFormatted"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>

                    <v-date-picker
                      v-model="dataItem.checkout"
                      @input="menuDateCheckout = false"
                      :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                      :min="minDateAllowed"
                      @change="getWorkHourDuration()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                  <h3>Time</h3>
                  <datetime
                    class="border-dt-picker minheighttime"
                    type="time"
                    input-id="menutimeadd"
                    value-zone="Asia/Bangkok"
                    format="HH:mm"
                    v-model="dataItem.timecheckout"
                    :max-datetime="getMaxTimeCheckOut()"
                    :disabled="isDisabledTimeFieldCheckOut"
                    @input="getWorkHourDuration()"
                  ></datetime>
                </v-col>
              </v-row>
  
              <v-row v-if="showDuration !=''">
                <v-col cols="12" sm="12" md="12" class="d-flex" v-if="showDuration != 'Start date/time must be before End date/time'">
                  <h3>Duration:</h3>&nbsp;&nbsp;<span style="color: green">{{ showDuration }}</span>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="d-flex" v-else>
                  <h3>Duration:</h3>&nbsp;&nbsp;<span style="color: red">{{ showDuration }}</span>
                </v-col>
                
              </v-row>
            </v-col>
            <v-col cols="12" sm="5" md="5">
              <h3>Details</h3>
              <v-textarea
                v-model="dataItem.detail"
                multi-line
                outlined
                dense
              ></v-textarea>
            </v-col>
          </v-row> -->
        </v-card-text>
        <br />
        <hr />
        <br />
        <div>
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn depressed width="100" class="mr-3 buttonblue" @click="save()">
                Save
              </v-btn>
              <v-btn to="/my-activity" depressed outlined width="100">
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "./computing/tolocalestringnumber";
import unity from "@/unity/unity";
const moment = require("moment");

export default {
  name: "New Activity",
  data() {
    return {
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      Emp_list: [],
      jobtitle_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      customer_list: [],
      menuDateCheckin: false,
      menuDateCheckout: false,
      dataItem: {
        userId: 0,
        customer_id: 0,
        jobtitle_id: 0,
        // checkin: "",
        // checkout: "",
        checkin: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        checkout: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        timecheckin: "",
        timecheckout: "",
        timecheckinadd: "",
        timecheckoutadd: "",
        hours: "",
        chargetype: "",
        prospect: "",
        detail: "",
        durationhour: 0,
        durationminute: 0,
      },
      addItem: {
        chargeType: "",
        images: "",
        company_id: 0,
        isCheckedOut: 1,
        userId: 0,
        departmentId: 0,
        jobTitleId: 0,
        customerId: 0,
        prospect: "",
        detail: "",
        status: "A",
        caseType: null,
        check_auto: 0,
        addby: "W",
      },
      showDuration: "",
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    computedDateCheckInFormatted() {
      return unity.formatDate(this.dataItem.checkin);
    },
    computedDateCheckOutFormatted() {
      return unity.formatDate(this.dataItem.checkout);
    },
    minDateAllowed() {
      return moment()
        .tz("Asia/Bangkok")
        .subtract(5, "days")
        .format("YYYY-MM-DD");
    },
    isTodayCheckin() {
      const selected = new Date(this.dataItem.checkin);
      const today = new Date();
      return (
        selected.toISOString().slice(0, 10) === today.toISOString().slice(0, 10)
      );
    },
    isDisabledTimeField() {
      return this.isTodayCheckin && this.isPastCurrentTimeLimit();
    },
    isTodayCheckOut() {
      const selected = new Date(this.dataItem.checkout);
      const today = new Date();
      return (
        selected.toISOString().slice(0, 10) === today.toISOString().slice(0, 10)
      );
    },
    isDisabledTimeFieldCheckOut() {
      return this.isTodayCheckOut && this.isPastCurrentTimeLimitCheckOut();
    },
  },

  watch: {
    "dataItem.checkin"(newVal) {
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (newVal === today && this.dataItem.timecheckin) {
        const time = moment.tz(this.dataItem.timecheckin, "Asia/Bangkok");
        const now = moment.tz("Asia/Bangkok");

        if (time.isAfter(now)) {
          this.dataItem.timecheckin = null;
        }
      }
    },
    "dataItem.checkout"(newVal) {
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (newVal === today && this.dataItem.timecheckout) {
        const time = moment.tz(this.dataItem.timecheckout, "Asia/Bangkok");
        const now = moment.tz("Asia/Bangkok");

        if (time.isAfter(now)) {
          this.dataItem.timecheckout = null;
        }
      }
    },
  },

  async mounted() {
    await api.checkVersion();
    this.loadEmp();
    this.loadCustomer();
    this.loadJobtitle();
    this.$hideLoader();
    this.$forceUpdate();
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
  },
  methods: {
    getMaxTime() {
      const selected = moment
        .tz(this.dataItem.checkin, "Asia/Bangkok")
        .format("YYYY-MM-DD");
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (selected === today) {
        return moment.tz("Asia/Bangkok").format("HH:mm");
      }
      return null;
    },
    getMaxTimeCheckOut() {
      const selected = moment
        .tz(this.dataItem.checkout, "Asia/Bangkok")
        .format("YYYY-MM-DD");
      const today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");

      if (selected === today) {
        return moment.tz("Asia/Bangkok").format("HH:mm");
      }
      return null;
    },
    isPastCurrentTimeLimit() {
      // Optional: ใช้ได้ถ้าต้องการเงื่อนไขซับซ้อนกว่านี้
      return false;
    },
    isPastCurrentTimeLimitCheckOut() {
      // Optional: ใช้ได้ถ้าต้องการเงื่อนไขซับซ้อนกว่านี้
      return false;
    },
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID),
      );

      this.Emp_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID),
      );

      this.jobtitle_list = result.data;
    },
    async getWorkHourDuration() {
      if (this.dataItem.checkout != "") {
        this.dataItem.checkout = this.dataItem.checkin;
        if (
          this.dataItem.timecheckin !== "" &&
          this.dataItem.timecheckout !== ""
        ) {
          // ดึงเฉพาะเวลา (HH:mm) จาก string ISO
          const checkinTime = moment(this.dataItem.timecheckin).format("HH:mm");
          const checkoutTime = moment(this.dataItem.timecheckout).format(
            "HH:mm",
          );

          // สร้าง moment ใหม่โดยใช้วันที่เดียวกัน เช่น 2000-01-01 เพื่อไม่ให้วันมีผล
          const baseDate = "2000-01-01";
          const checkin = moment(
            `${baseDate} ${checkinTime}`,
            "YYYY-MM-DD HH:mm",
          );
          const checkout = moment(
            `${baseDate} ${checkoutTime}`,
            "YYYY-MM-DD HH:mm",
          );

          if (checkin.isSameOrAfter(checkout)) {
            this.showDuration = "Start date/time must be before End date/time";
            return;
          }

          let totalMinutes = checkout.diff(checkin, "minutes");

          // ถ้า checkout < checkin แปลว่าเวลาข้ามคืน
          if (totalMinutes < 0) {
            totalMinutes += 1440; // เพิ่ม 24 ชั่วโมง (1440 นาที)
          }

          const hours = Math.floor(totalMinutes / 60);
          const minutes = totalMinutes % 60;

          if (hours > 0) {
            if (minutes > 0) {
              this.showDuration = `${hours} Hours ${minutes} Minute`;
            } else {
              this.showDuration = `${hours} Hours`;
            }
          } else {
            this.showDuration = `${minutes} Minute`;
          }
        }
      }
    },
    async save() {
      if (this.dataItem.userId == "" || this.dataItem.userId == null) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Employee ",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (
        this.dataItem.jobtitle_id == "" ||
        this.dataItem.jobtitle_id == null
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Work Case ",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (this.dataItem.checkin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Date",
          "text-h5 red--text text-center",
        );
        return;
      } else {
        this.dataItem.checkout = this.dataItem.checkin;
      }

      if (this.dataItem.timecheckin == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Start Time",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.dataItem.timecheckout == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด End Time",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (this.dataItem.chargetype == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Charge-Type ",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (this.dataItem.detail == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณากรอกรายละเอียด Details ",
          "text-h5 red--text text-center",
        );
        return;
      }

      const checkinTime = moment(this.dataItem.timecheckin).format("HH:mm");
      const checkoutTime = moment(this.dataItem.timecheckout).format("HH:mm");
      const baseDate = "2000-01-01";
      const checkin = moment(`${baseDate} ${checkinTime}`, "YYYY-MM-DD HH:mm");
      const checkout = moment(
        `${baseDate} ${checkoutTime}`,
        "YYYY-MM-DD HH:mm",
      );
      const checkinFull = moment(
        `${this.dataItem.checkin} ${moment(this.dataItem.timecheckin).format("HH:mm:ss")}`,
        "YYYY-MM-DD HH:mm:ss"
      ).add(7, 'hours');
      if (checkin.isSameOrAfter(checkout)) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Start date/time must be before End date/time",
          "text-h5 red--text text-center",
        );
        return;
      }
      let totalMinutes = checkout.diff(checkin, "minutes");
      var departmentIduser = 0;
      try {
        var res = await api.getAccountByid(Number(this.dataItem.userId))
        departmentIduser = Number(res.data[0].dep_id)
      } catch (error) {
        console.error(error)
      }

      var addItem = {};
      addItem.chargeType = this.dataItem.chargetype;
      addItem.company_id = Number(localStorage.getItem(server.COMPANYID));
      addItem.checkInDate = checkinFull.format("YYYY-MM-DD HH:mm:ss");
      addItem.checkOutDate = `${this.dataItem.checkout} ${moment(
        this.dataItem.timecheckout,
      ).format("HH:mm:ss")}`;
      addItem.isCheckedOut = true;
      addItem.userId = this.dataItem.userId;
      addItem.departmentId = departmentIduser;
      addItem.jobTitleId = this.dataItem.jobtitle_id;
      addItem.customerId = this.dataItem.customer_id;
      addItem.prospect = this.dataItem.prospect;
      addItem.detail = this.dataItem.detail.replace(/'/g, "\\'");
      addItem.duration = Number(totalMinutes);
      addItem.addby = "W";
      addItem.check_auto = 0;
      addItem.status = "A";
      addItem.type = "A"; // ✅ เพิ่มตรงนี้

      this.$showLoader();
      const res_updateAct = await api.createActivityEmp(addItem);
      this.$hideLoader();
      if (res_updateAct.status == 200 || res_updateAct.status == 201) {
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          "/my-activity",
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  async beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
  async created() { },
};
</script>

<style scoped>
.border-dt-picker {
  border: 1px solid;
  /* border-radius: 5px; */
  height: 30px;
}

.minheighttime {
  min-height: 40px;
  cursor: pointer;
  font-size: initial;
  padding-top: 7px;
  padding-left: 7px;
}
</style>
